import { Link } from "gatsby";
import React from "react";
import { formatCreatedDate } from "../../includes/utils";
import GeneralBackground from "../../global/assets/spaces/general.svg";
import GrowthStrategyBackground from "../../global/assets/spaces/growth-strategy.svg";
import ProgramManagementBackground from "../../global/assets/spaces/program-management.svg";
import EngineeringBackground from "../../global/assets/spaces/engineering.svg";
import QualityAssuranceBackground from "../../global/assets/spaces/quality-assurance.svg";
import "./ContentHeader.scss";

export interface IContentHeaderProps {
  title: string;
  labels?: string[];
  createdDate?: Date;
  readTime?: number;
}

const graphicMap: { [key: string]: JSX.Element } = {
  "general": <GeneralBackground/>,
  "growth-strategy": <GrowthStrategyBackground/>,
  "program-management": <ProgramManagementBackground/>,
  "engineering": <EngineeringBackground/>,
  "quality-assurance": <QualityAssuranceBackground/>
};

const ContentHeader = ({ title, labels, createdDate, readTime }: IContentHeaderProps): JSX.Element => {
  const formatLabels = (labels: string[]): JSX.Element[] => {
    const labelElements: JSX.Element[] = [];
  
    for (const label of labels) {
      if (labelElements.length === 3) {
        break;
      }

      labelElements.push(<Link key={label} to={`/search?q=${label}`}>{label}</Link>);
    }
  
    return labelElements;
  };

  const headerGraphic: JSX.Element = graphicMap[title.toLowerCase().replace(/\s/g, "-").replace("-articles", "")];
  
  const createdElement: JSX.Element | null = createdDate ?
    <p className="ContentHeader__articleInfo">
      <div className="ContentHeader__createdDate">Created on {formatCreatedDate(createdDate)}</div>
      <div className="ContentHeader__readTime">{readTime} min read</div>
    </p> : null;
  const labelElement: JSX.Element | null = labels ? <div className="ContentHeader__labels">{formatLabels(labels)}</div> : null;

  return (
    <div className="ContentHeader">
      {headerGraphic}
      <div className="ContentHeader__content">
        <h1>{title}</h1>
        <div className="ContentHeader__subheader">
          {createdElement}
          {/* TODO: Add back social links */}
          {/* <div className="ContentHeader__socials">
            <div/>
            <div/>
            <div/>
            <div/>
          </div> */}
        </div>
        {labelElement}
      </div>
    </div>
  );
};
export default ContentHeader;